import global from "@/locales/fr-FR/global";
import error403 from "@/locales/fr-FR/errors/403";
import error404 from "@/locales/fr-FR/errors/404";
import error500 from "@/locales/fr-FR/errors/500";
import error503 from "@/locales/fr-FR/errors/503";
import error504 from "@/locales/fr-FR/errors/504";
import maintenance from "@/locales/fr-FR/auth/maintenance";
import toast from "@/locales/fr-FR/toast/toast";
import login from "@/locales/fr-FR/auth/login";
import onboarding from "@/locales/fr-FR/auth/onboarding";
import loginPageSteps from "@/locales/fr-FR/loginPageSteps";
import dashboard from "@/locales/fr-FR/dashboard/dashboard";
import account from "@/locales/fr-FR/account/account";
import mailbox from "@/locales/fr-FR/account/mailbox";
import bankstatement from "@/locales/fr-FR/account/bankstatement";
import myApps from "@/locales/fr-FR/my-apps/myApps";
import about from "@/locales/fr-FR/about/about";
import contactService from "@/locales/fr-FR/about/contactService";
import salesPromotions from "@/locales/fr-FR/sales/promotions";
import brochures from "@/locales/fr-FR/sales/brochures";
import shop from "@/locales/fr-FR/shop/data";
import priceList from "@/locales/fr-FR/shop/priceList";
import staff from "@/locales/fr-FR/dashboard/staff";
import promotions from "@/locales/fr-FR/promotions";
import points from "@/locales/fr-FR/points";
import trainings from "@/locales/fr-FR/trainings/trainings";
import vouchers from "@/locales/fr-FR/vouchers/vouchers";
import generateReport from "@/locales/fr-FR/generate-report/generateReport";
import wholesaler from "@/locales/fr-FR/wholesaler/wholesaler";
import widgets from "@/locales/fr-FR/widgets/widgets";
import media from "@/locales/fr-FR/media/index";
import product from "@/locales/fr-FR/product/index";
import message from "@/locales/fr-FR/message/index";
import commitmentLetter from "@/locales/fr-FR/account/commitmentLetter";
import multiplicator from "@/locales/fr-FR/multiplicator";
import consents from "@/locales/fr-FR/consents/consents";
import investment from "@/locales/fr-FR/investment/data";
import kickback from "@/locales/fr-FR/kickback";
//prettier-ignore
const messages = {
  loginPageSteps: loginPageSteps.messages,
  global: global.messages,
  error403: error403.messages,
  error404: error404.messages,
  error500: error500.messages,
  error503: error503.messages,
  error504: error504.messages,
  maintenance: maintenance.messages,
  toast: toast.messages,
  login: login.messages,
  onboarding: onboarding.messages,
  dashboard: dashboard.messages,
  multiplicator: multiplicator.messages,
  account: account.messages,
  mailbox: mailbox.messages,
  myApps: myApps.messages,
  bankstatement: bankstatement.messages,
  about: about.messages,
  contactService: contactService.messages,
  salesPromotions: salesPromotions.messages,
  shop: shop.messages,
  staff: staff.messages,
  promotions: promotions.messages,
  points: points.messages,
  brochures: brochures.messages,
  trainings: trainings.messages,
  vouchers: vouchers.messages,
  generateReport: generateReport.messages,
  wholesaler: wholesaler.messages,
  widgets: widgets.messages,
  media: media.messages,
  priceList: priceList.messages,
  productInfo: product.messages,
  message: message.messages,
  commitmentLetter: commitmentLetter.messages,
  consents: consents.messages,
  investment: investment.messages,
  kickback: kickback.messages,
  productBrochures: {
    BDriveTitle: "Images de produits",
    BDriveLinkText: "Lien vers le portail IMAGES PRODUITS",
  },
}

export default {
  locale: "fr-FR",
  messages,
};
